import "./shipping_instructions";
import "./controllers";

document.addEventListener("DOMContentLoaded", function () {
  var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  document.cookie = "browser_timezone=" + timezone + "; path=/";
});
